import classNames from 'classnames';
import './styles.scss';

const Button = ({
  text = 'Submit',
  disabled = false,
  type,
  onClick,
  className,
}) => {
  return (
    <button
      type={type}
      className={classNames('button', className, {
        'button--disabled': disabled,
      })}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

export default Button;
